import { useControllerAppModel } from '@/controller/models/ControllerAppModel';
import { Card, CardBody, Dialog } from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

const inactiveKickTimeMs = 10_000;

export const InactiveDialog = observer(() => {
  const appModel = useControllerAppModel();
  const [, updater] = useState(0);
  const user = appModel.user;

  useEffect(() => {
    if (!user || user.active) {
      return;
    }

    const interval = setInterval(() => {
      updater((prev) => prev + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [user]);

  if (!user) {
    return null;
  }

  const timeInactive =
    user.timeWentInactive === null ? null : Date.now() - user.timeWentInactive;

  const timeLeft = timeInactive === null ? null : inactiveKickTimeMs - timeInactive;

  return (
    <Dialog open={!user.active}>
      <Card>
        {timeLeft !== null && timeLeft < 0 ? (
          <>
            <p>You have been kicked due to inactivity</p>
            <p>Refresh the page to rejoin</p>
          </>
        ) : (
          <>
            <p>You are inactive</p>
            <p>
              You will be kicked in {Math.floor((timeLeft ?? inactiveKickTimeMs) / 1000)}
            </p>
          </>
        )}
      </Card>
    </Dialog>
  );
});
